import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { CustomerImageModule } from '../customer/image/customer-image.module';
import { CustomerDetailModule } from '../driver/components/customer-detail/customer-detail.module';
import { AttributeTypeService } from '../driver/services/attribute-type.service';
import { CredentialIssuanceApplicationService } from '../driver/services/credential-issuance-application.service';
import { CredentialTypeAttributeTypeMapService } from '../driver/services/credential-type-attribute-type-map.service';
import { DriverCredentialService } from '../driver/services/driver-credential.service';
import { LicenseClassTypeService } from '../driver/services/license-class-type.service';
import { NoteModule } from '../note/note.module';
import { SearchModule } from '../shared/components/search/search.module';
import { MaterialModule } from '../shared/material.module';
import { SharedModule } from '../shared/shared.module';
import { CommonDocumentModalComponent } from './common-document-modal.component';
import { AddCredentialModalComponent } from './driver-credential/add-credential-modal.component';
import { DriverRecordCredentialsComponent } from './driver-credential/driver-record-credentials.component';
import { DriverRecordCoreModule } from './driver-record-core.module';
import { DriverRecordCredentialComponent } from './driver-credential/driver-record-credential.component';

@NgModule({
    declarations: [
        AddCredentialModalComponent,
        CommonDocumentModalComponent,
        DriverRecordCredentialsComponent,
        DriverRecordCredentialComponent
    ],
    providers: [
        AttributeTypeService,
        CredentialIssuanceApplicationService,
        CredentialTypeAttributeTypeMapService,
        DriverCredentialService,
        LicenseClassTypeService
    ],
    imports: [
        CalendarModule,
        CustomerImageModule,
        DriverRecordCoreModule,
        MaterialModule,
        MaterialModule.forRoot(),
        MultiSelectModule,
        NoteModule,
        SearchModule,
        SharedModule,
        TableModule,
        CustomerDetailModule
    ],
    exports: [
        CommonDocumentModalComponent,
        DriverRecordCredentialsComponent,
        DriverRecordCredentialComponent,
    ]
})
export class DriverRecordSharedModule {
}
